import ButtonTemplate from '@ui/Button/Button';
import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';
import { breakpoints, theme } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;

export const PicWrapper = styled.div`
    margin: ${rem(15)};
    width: 90%;
    @media (min-width: ${breakpoints.md}px) {
        width: 40%;
    }
    @media (min-width: ${breakpoints.lg}px) {
        width: 30%;
    }
`;

export const PicSource = styled.img`
    width: 100%;
    cursor: pointer;
    border-radius: ${rem(16)};
`;

export const Title = styled.h3`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h3};
    width: 100%;
    text-align: center;
    margin-top: ${rem(50)};
    margin-bottom: ${rem(20)};
`;
